<template>
  <VerifikasiRealisasiForm mode="Verifikasi" module="Realisasi Indikator Kinerja"> </VerifikasiRealisasiForm>
</template>

<script>
import VerifikasiRealisasiForm from './form-realisasi';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';

const VerifikasiRealisasiAdd = {
  name: 'VerifikasiRealisasiAdd',
  components: { VerifikasiRealisasiForm },
  setup() {
    const store = useStore();
    onBeforeRouteLeave(() => {
      store.commit('axiosResetState');
    });
  },
};

export default VerifikasiRealisasiAdd;
</script>
